export const MagnifyingGlass = () => (
  <svg width="31" height="30" viewBox="0 0 31 30" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
    <path
      d="M2.86083 4.99219H18.0064C19.6051 4.99219 20.8673 6.31236 20.8673 7.88805V26.3705C20.8673 27.9888 19.5631 29.2664 18.0064 29.2664H2.86083C1.26213 29.2664 0 27.9462 0 26.3705V7.88805C0 6.31236 1.26213 4.99219 2.86083 4.99219Z"
      fill="#018374"
    />
    <path
      d="M7.95711 0.733582H20.0261C22.07 0.733582 23.7247 2.46435 23.7247 4.60236V21.1974C23.7247 23.3355 22.07 25.0662 20.0261 25.0662H7.95711C5.91317 25.0662 4.25854 23.3355 4.25854 21.1974V4.60236C4.25854 2.46435 5.91317 0.733582 7.95711 0.733582Z"
      fill="white"
      stroke="#018374"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.12988 12.0345H20.7561"
      stroke="#018374"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.12988 16.1115H20.7561"
      stroke="#018374"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.12988 8.31866H20.7561"
      stroke="#018374"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.12988 4.60254H20.7561"
      stroke="#018374"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <g clipPath="url(#clip0_3128_12688)">
      <path
        d="M21.4289 20.2116C24.9301 20.2116 27.7683 17.3464 27.7683 13.812C27.7683 10.2776 24.9301 7.41235 21.4289 7.41235C17.9278 7.41235 15.0896 10.2776 15.0896 13.812C15.0896 17.3464 17.9278 20.2116 21.4289 20.2116Z"
        fill="white"
        stroke="#018374"
        strokeMiterlimit="10"
        strokeLinejoin="round"
      />
      <path
        d="M15.2305 14.3434C15.2305 14.3434 15.4087 14.3434 16.9354 14.3434"
        stroke="#018374"
        strokeWidth="1.21569"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.1538 14.3434C18.1538 14.3434 18.6021 14.3434 22.4412 14.3434"
        stroke="#018374"
        strokeWidth="1.21569"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.363 10.3792H19.3299"
        stroke="#018374"
        strokeWidth="1.21569"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.9578 10.3792H23.9246"
        stroke="#018374"
        strokeWidth="1.21569"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <path
      d="M29.6464 22.9314C29.8417 23.1267 30.1582 23.1267 30.3535 22.9314C30.5488 22.7361 30.5488 22.4195 30.3535 22.2243L29.6464 22.9314ZM25.5476 18.8326L29.6464 22.9314L30.3535 22.2243L26.2547 18.1255L25.5476 18.8326Z"
      fill="#018374"
    />
    <defs>
      <clipPath id="clip0_3128_12688">
        <rect width="14.2768" height="15.4344" fill="white" transform="translate(14.7036 7.14349)" />
      </clipPath>
    </defs>
  </svg>
)
